module.exports = __webpack_public_path__ + "img/android2.b821513e.jpg";